// extracted by mini-css-extract-plugin
export var CancelIcon = "index-module--CancelIcon--b4d48";
export var Error = "index-module--Error--720dd";
export var LargeError = "index-module--LargeError--b7916";
export var RTL = "index-module--RTL--966f4";
export var SmallMessage = "index-module--SmallMessage--474f6";
export var Title = "index-module--Title--3956f";
export var shake = "index-module--shake--db4e3";